<template>
    <div id="about">
        <section class="relative">
            <background />
            <row class="container" :justify="'around'" :align="'stretch'">
                <column id="business" :width="1/3" v-lazy:background-image="mitBusiness" />
                <column :width="1/2">
                    <div class="light-block">
                        <h1>About MIT Services.</h1>
                        <span>
                            MIT Services is a proudly Australian company represented in all major
                            capital cities and regional areas.<br /> <br />
                            Our corporate agenda is not based on empty promises. Our organisation
                            thrives on challenges, and is seen as an exciting workplace to our customers, and
                            staff. <br /> <br />
                            Our clients profit from real outcomes.
                        </span>
                    </div>
                </column>
            </row>
        </section>
        <profiles />
        <pipeline />
    </div>    
</template>
<script>
import { mitBusiness } from '../../assets';
import profiles from './Staff-Profiles';
import pipeline from './Pipeline';
export default {
    data () {
        return {
            mitBusiness
        }
    },
    components: {
        profiles,
        pipeline
    }
}
</script>
<style scoped>
    #business {
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
    }
    .background {
		background: #0683c9 url("../../assets/background/network.jpg") no-repeat fixed center;
	}
</style>